var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditSquare = function SvgEditSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "edit_square_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#edit_square_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#583EEE",
    d: "M3.958 16.625q-.653 0-1.118-.465a1.53 1.53 0 0 1-.465-1.119V3.958q0-.653.465-1.118t1.118-.465h7.066L9.441 3.958H3.958V15.04h11.084V9.54l1.583-1.583v7.085q0 .653-.465 1.119t-1.118.465zm3.167-4.75V8.51l7.264-7.264q.237-.237.534-.356t.594-.119a1.56 1.56 0 0 1 1.128.475l1.108 1.129q.217.237.337.524.118.287.118.584t-.108.584a1.5 1.5 0 0 1-.347.524l-7.263 7.284zm1.583-1.584h1.109L14.408 5.7l-.554-.555-.574-.554-4.572 4.572z"
  }))));
};
export default SvgEditSquare;